module.exports = __webpack_public_path__ + "img/overdue.937e6e9a.svg";